// V1
import "./index.scss";
import "./i18n/i18n.client";

import { hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryProvider, restoreQueryClient } from "./providers/queryProvider";
import { HelmetProvider } from "@dr.pogodin/react-helmet";
import App from "./app";

async function bootstrap() {
  await restoreQueryClient();

  hydrateRoot(
    document.getElementById("root"),
    <BrowserRouter>
      <QueryProvider>
        <HelmetProvider>
          <App dynamicRoutes={window.__DYNAMIC_ROUTES__} />
        </HelmetProvider>
      </QueryProvider>
    </BrowserRouter>
  );
}

bootstrap();

// V2
// import "./index.scss";
// import "./i18n/i18n.client";

// import { hydrateRoot } from "react-dom/client";
// import { BrowserRouter } from "react-router-dom";
// import { QueryProvider, restoreQueryClient } from "./providers/queryProvider";
// import { HelmetProvider } from "@dr.pogodin/react-helmet";
// import App from "./app";

// const dynamicRoutes = window.__DYNAMIC_ROUTES__ ?? [];
// const defaultLanguage = window.__DEFAULT_LANGUAGE__ ?? "am";

// export function Client() {
//   // const [isClient, setIsClient] = useState(false);

//   // useEffect(() => {
//   //   setIsClient(true);
//   // }, []);

//   return (
//     <BrowserRouter>
//       <QueryProvider>
//         <HelmetProvider>
//           {/* {isClient && ( */}
//             <App
//               dynamicRoutes={dynamicRoutes}
//               defaultLanguage={defaultLanguage}
//             />
//           {/* )} */}
//         </HelmetProvider>
//       </QueryProvider>
//     </BrowserRouter>
//   );
// }

// async function bootstrap() {
//   await restoreQueryClient();
//   hydrateRoot(document.getElementById("root"), <Client />);
// }

// bootstrap();


// V1 EXPERIMENTAL
// import "./index.scss";
// import "./i18n/i18n.client";

// import { hydrateRoot } from "react-dom/client";
// import { BrowserRouter } from "react-router-dom";
// import { QueryProvider, restoreQueryClient } from "./providers/queryProvider";
// import { HelmetProvider } from "@dr.pogodin/react-helmet";
// import App from "./app";

// const dynamicRoutes = window.__DYNAMIC_ROUTES__ ?? [];

// async function bootstrap() {
//   await restoreQueryClient();

//   hydrateRoot(
//     document.getElementById("root"),
//     <BrowserRouter>
//       <QueryProvider>
//         <HelmetProvider>
//           <App dynamicRoutes={dynamicRoutes} />
//         </HelmetProvider>
//       </QueryProvider>
//     </BrowserRouter>
//   );
// }

// bootstrap();
